<template>
  <div class="brucdcum-header">
    <div class="brucdcum-header-row">
      <div class="brucdcum-breadcrumb">
        <button
          v-if="showBackButton"
          class="brucdcum-back-btn"
          @click="goBack"
          :disabled="isNavigating"
          aria-label="Go back"
          title="Back"
        >
          <i class="bi bi-arrow-left"></i>
        </button>
        <span
          v-for="(item, index) in breadcrumbItems"
          :key="index"
          class="brucdcum-breadcrumb-item"
          :class="{ 'brucdcum-breadcrumb-current': index === breadcrumbItems.length - 1 }"
        >
          <span v-if="index > 0" class="brucdcum-breadcrumb-separator">&gt;</span>
          {{ item }}
        </span>
      </div>
      <div v-if="showAnnaAssistantButton || $slots.actions" class="brucdcum-header-actions">
        <slot name="actions" />
        <button
          v-if="showAnnaAssistantButton"
          type="button"
          class="brucdcum-anna-assistant-btn"
          :class="{ 'brucdcum-anna-assistant-btn--active': annaAssistantOpen }"
          title="Open Anna AI Agent"
          @click="toggleAnnaAssistant"
        >
          <i class="bi bi-stars" aria-hidden="true"></i>
          <span>Anna AI Agent</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import './BrucdcumHeader.css';
import { useAnnaAssistant } from '@/composables/useAnnaAssistant';

export default {
  name: 'BrucdcumHeader',
  props: {
    title: {
      type: String,
      required: false
    },
    breadcrumb: {
      type: Array,
      required: false,
      default: () => []
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    backFallback: {
      type: String,
      default: ''
    },
    showAnnaAssistantButton: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { isOpen, toggle } = useAnnaAssistant();
    return {
      annaAssistantOpen: isOpen,
      toggleAnnaAssistant: toggle
    };
  },
  data() {
    return {
      isNavigating: false,
      removeAfterEachHook: null,
      removeErrorHook: null
    };
  },
  computed: {
    breadcrumbItems() {
      if (this.breadcrumb && this.breadcrumb.length > 0) {
        return this.breadcrumb;
      }
      // Fallback to title if breadcrumb is not provided
      return this.title ? [this.title] : [];
    }
  },
  created() {
    this.removeAfterEachHook = this.$router.afterEach(() => {
      this.isNavigating = false;
    });

    this.removeErrorHook = this.$router.onError(() => {
      this.isNavigating = false;
    });
  },
  beforeUnmount() {
    if (typeof this.removeAfterEachHook === 'function') {
      this.removeAfterEachHook();
      this.removeAfterEachHook = null;
    }
    if (typeof this.removeErrorHook === 'function') {
      this.removeErrorHook();
      this.removeErrorHook = null;
    }
  },
  methods: {
    goBack() {
      if (this.isNavigating) {
        return;
      }
      this.isNavigating = true;

      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      if (this.backFallback) {
        this.$router.push(this.backFallback);
        return;
      }

      const companyId = this.$route.params.id;
      if (companyId) {
        this.$router.push(`/company/${companyId}/dashboard/overview`);
      } else {
        this.$router.push('/home');
      }
    }
  }
}
</script>
